/**
 * Load all parameter types from RecordParameterTypes into a Map.
 * @param database - Opened SQLite database handle
 * @returns Map of type id to ParameterType
 */
function loadParameterTypes(database) {
    const rows = database.selectObjects(`
    SELECT
      Id                AS id,
      Guid              AS guid,
      UniformResourceName AS urn,
      FriendlyName      AS friendlyName,
      ParameterDataType AS dataType,
      Description       AS description,
      DataUnitsUrn      AS dataUnitsUrn
    FROM RecordParameterTypes
  `);
    const types = new Map();
    for (const row of rows) {
        const parameterType = row;
        types.set(parameterType.id, parameterType);
    }
    return types;
}
/**
 * Build the hierarchical parameter tree for a given root parameter type.
 *
 * Queries all tree nodes that share the given root type, resolves their
 * parameter types, and assembles them into a tree structure.
 * @param database - Opened SQLite database handle
 * @param rootParameterTypeId - The root parameter type id for the record
 * @returns The root TreeNode with all children populated
 */
export function buildParameterTree(database, rootParameterTypeId) {
    const parameterTypes = loadParameterTypes(database);
    const rows = database.selectObjects(`
    SELECT
      Id              AS id,
      ParameterTypeId AS parameterTypeId,
      ParentNodeId    AS parentNodeId,
      SiblingIndex    AS siblingIndex
    FROM RecordParameterTreeNodes
    WHERE RootParameterTypeId = ?
    ORDER BY SiblingIndex
  `, [rootParameterTypeId]);
    // Index all nodes by id
    const nodeMap = new Map();
    for (const row of rows) {
        const rawNode = row;
        const parameterType = parameterTypes.get(rawNode.parameterTypeId);
        if (!parameterType) {
            throw new Error(`Unknown parameter type id ${rawNode.parameterTypeId} for tree node ${rawNode.id}`);
        }
        nodeMap.set(rawNode.id, {
            ...rawNode,
            parameterType,
            children: [],
        });
    }
    // Assemble tree by linking children to parents
    let root;
    for (const node of nodeMap.values()) {
        if (node.parentNodeId === null) {
            root = node;
        }
        else {
            const parent = nodeMap.get(node.parentNodeId);
            if (parent) {
                parent.children.push(node);
            }
        }
    }
    if (!root) {
        throw new Error(`No root tree node found for RootParameterTypeId ${rootParameterTypeId}`);
    }
    // Sort children by sibling index at each level
    sortChildren(root);
    return root;
}
/**
 * Recursively sort children of each tree node by sibling index.
 * @param node - The tree node whose children to sort
 */
function sortChildren(node) {
    node.children = node.children.toSorted((a, b) => a.siblingIndex - b.siblingIndex);
    for (const child of node.children) {
        sortChildren(child);
    }
}
//# sourceMappingURL=readParameterTree.js.map